import { ContainerTypes, HomePageEditorContextStateType, HomePageEditorContextValueType, HomePageEditorProviderProps } from '@src/lib/types/home-page-editor';
import { useInputHelper } from '@src/utils/inputs-helper';
import _ from 'lodash';
import React, { createContext, useContext } from 'react';
import { useServices } from './hooks';

const initialState: HomePageEditorContextStateType = {
  "cta": {
    "link": "",
    "text": ""
  },
  "mainBlock": {
    "description": "",
    "image": ""
  },
  "subBlock1": {
    "description": "",
    "image": ""
  },
  "subBlock2": {
    "description": "",
    "image": ""
  },
  "subBlock3": {
    "description": "",
    "image": ""
  }
} as HomePageEditorContextStateType

export const HomePageEditorContext = createContext<HomePageEditorContextValueType>({} as HomePageEditorContextValueType);

const HomePageEditorProvider = ({ children }: HomePageEditorProviderProps) => {
  const [error, setError ] = React.useState({});
  const [success, setSuccess ] = React.useState(false);
  const [openDescription, setOpenDescription ] = React.useState<boolean>(false);
  const [container, setContainer ] = React.useState<ContainerTypes>("" as ContainerTypes);
  const { state, onDispatch, onSetInitial } = useInputHelper(initialState);
  const { data, onPublish } = useServices();

  const onSubmit = React.useCallback(() => {
    const Err: any = {};
    if(!state.mainBlock.image){
      Err["mainBlock.image"] = true
    }
    if(!state.mainBlock.description){
      Err["mainBlock.description"] = true
    }
    if(!state.subBlock1.image){
      Err["subBlock1.image"] = true
    }
    if(!state.subBlock1.description){
      Err["subBlock1.description"] = true
    }
    if(!state.subBlock2.image){
      Err["subBlock2.image"] = true
    }
    if(!state.subBlock2.description){
      Err["subBlock2.description"] = true
    }
    if(!state.subBlock3.image){
      Err["subBlock3.image"] = true
    }
    if(!state.subBlock3.description){
      Err["subBlock3.description"] = true
    }
    if (!state?.cta?.text) {
      Err["cta.text"] = true;
    }
    if (!state?.cta?.link) {
      Err["cta.link"] = true;
    }

    setError(Err);

    if(_.isEmpty(Err)){
      onPublish.mutate(state, {
        onSuccess: () => {
          setSuccess(true)
        }
      });
    }
  }, [state, onPublish]);

  const isDirty = !_.isEqual(state, data ?? initialState);

  const value = {
    state,
    error,
    onDispatch,
    onSubmit,
    isLoading: onPublish.isPending,
    isDirty,
    container, setContainer,
    openDescription, setOpenDescription,
    success, setSuccess
  };

  React.useEffect(() => {
    if(!_.isEmpty(error)){
      setError({});
    }
  },[state, error]);

  React.useEffect(() => {
    if(!_.isEmpty(data)){
      onSetInitial({...data});
    }
  },[data, onSetInitial]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <HomePageEditorContext.Provider value={value}>
      {children}
    </HomePageEditorContext.Provider>
  );
};

export const useHomePageEditorContext = () => {
  return useContext(HomePageEditorContext);
}

export default HomePageEditorProvider;
